import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getBaseUrl = () => {
  if (!API_BASE_URL) {
    throw new Error('API base URL is not configured. Please set REACT_APP_API_BASE_URL.');
  }
  return API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
};

export const siteVisitService = {
  async createSiteVisit(payload) {
    try {
      const base = getBaseUrl();
      const url = `${base}/api/site-visits`;
      const response = await axios.post(url, payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to create site visit');
      } else if (error.request) {
        throw new Error('No response from server. Please check your connection.');
      } else {
        throw new Error(error.message || 'Failed to create site visit');
      }
    }
  },

  async updateSiteVisit(siteVisitId, payload) {
    try {
      const base = getBaseUrl();
      const url = `${base}/api/site-visits/${siteVisitId}`;
      const response = await axios.put(url, payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to update site visit');
      } else if (error.request) {
        throw new Error('No response from server. Please check your connection.');
      } else {
        throw new Error(error.message || 'Failed to update site visit');
      }
    }
  },

  async getSiteVisits(params = {}) {
    try {
      const base = getBaseUrl();
      const url = `${base}/api/site-visits/hierarchy-wise`;
      const response = await axios.get(url, {
        params,
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to fetch site visits');
      } else if (error.request) {
        throw new Error('No response from server. Please check your connection.');
      } else {
        throw new Error(error.message || 'Failed to fetch site visits');
      }
    }
  },

  async getSiteVisitById(siteVisitId) {
    try {
      const base = getBaseUrl();
      const url = `${base}/api/site-visits/${siteVisitId}`;
      const response = await axios.get(url, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to fetch site visit');
      } else if (error.request) {
        throw new Error('No response from server. Please check your connection.');
      } else {
        throw new Error(error.message || 'Failed to fetch site visit');
      }
    }
  },

  async createSiteVisitFollowUp(payload) {
    try {
      const base = getBaseUrl();
      const url = `${base}/api/site-visit-follow-ups`;
      const response = await axios.post(url, payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to create follow-up');
      } else if (error.request) {
        throw new Error('No response from server. Please check your connection.');
      } else {
        throw new Error(error.message || 'Failed to create follow-up');
      }
    }
  },

  async getSiteVisitFollowUps(params = {}) {
    try {
      const base = getBaseUrl();
      const url = `${base}/api/site-visit-follow-ups`;
      const response = await axios.get(url, {
        params,
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to fetch follow-ups');
      } else if (error.request) {
        throw new Error('No response from server. Please check your connection.');
      } else {
        throw new Error(error.message || 'Failed to fetch follow-ups');
      }
    }
  },
};

